import { Injectable, ViewChild, ElementRef} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import * as $ from 'jquery'; 
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  private readonly _html= new BehaviorSubject<string>('');
  private _currentHtml: string = '';
  html$ = this._html.asObservable();
  
  @ViewChild('mmcCanvasMain') canvasRef: ElementRef;
  
  constructor(
    private _http: HttpClient,
    private dataService: DataService    
    ) { }
    private _url: string = 'https://bimsources.com/zoning/api/print.php';
  // private _url: string = 'http://test.hybrid.pl/rockwool/zoning/api/print.php';

  // private _url: string = 'http://localhost/rockwool/zoning/src/api/print.php';


  set html(content:string){
    this._currentHtml=content;
  }

  get html(){
    return this._currentHtml;
  }

  createCanvas(){
    let canvasMain=$('#mmcCanvasMain')[0];
    let scaleBar=$('#mmcScaleBar')[0];
    let printCanvas=document.createElement('canvas')
    let pcCTX=printCanvas.getContext('2d')
    printCanvas.width=canvasMain.width
    printCanvas.height=canvasMain.height


    pcCTX.fillStyle="white";
    pcCTX.fillRect(0,0,canvasMain.width,canvasMain.height)
    pcCTX.drawImage(canvasMain,0,0)

    pcCTX.drawImage(scaleBar,canvasMain.width-scaleBar.width-15,canvasMain.height-scaleBar.height-15)
    return printCanvas;
  }  

  print(){

    var form = document.getElementById('invisibleform');
    $(form).submit();
  }

  parseData(){
    return this.dataService.currentData.results;
  }

  get url(){
    return this._url;
  }



  
}
